import { useQuery } from '@tanstack/react-query';
import { ShieldCheck } from 'lucide-react';
import { api } from '../lib/api';
import { Card, Spinner } from './ui';
import { PlanAndPayment } from './plan-payment';

/**
 * Último paso del alta: elegir mensual o anual y guardar un método de pago (0 €). Mientras falte, el panel de la
 * empresa muestra esta pantalla. Los fichajes nunca se bloquean.
 */
export function PaymentGate() {
  const { data, isLoading, refetch } = useQuery({ queryKey: ['billing'], queryFn: () => api.get<any>('/api/v1/billing') });
  if (isLoading || !data) return <Spinner />;
  return (
    <div className="mx-auto max-w-2xl py-4">
      <h1 className="text-2xl font-bold tracking-tight text-brand-950">Completa tu alta</h1>
      <p className="mt-1 text-slate-600">
        Tienes <strong>{data.terms.trialDays} días de prueba gratis</strong> con todas las funciones. Elige cómo quieres pagar después y guarda un método de pago: <strong>hoy no se cobra nada (0 €)</strong> y puedes cancelar antes de que acabe la prueba.
      </p>
      <Card className="mt-5">
        <PlanAndPayment data={data} onChanged={() => refetch()} compact />
      </Card>
      <p className="mt-4 flex items-center gap-2 text-xs text-slate-500">
        <ShieldCheck className="h-4 w-4" /> Pago seguro con Stripe. WulfTime no guarda los datos de tu tarjeta ni de tu cuenta bancaria.
      </p>
    </div>
  );
}
